import { render, staticRenderFns } from "./AmostrasLogsCustomLabel.vue?vue&type=template&id=75ef0982&"
import script from "./AmostrasLogsCustomLabel.vue?vue&type=script&lang=ts&"
export * from "./AmostrasLogsCustomLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports